import { HttpErrorResponse } from '@angular/common/http';
import { passwordResetErrorMessage, passwordResetServiceUnavailableMessage } from '../constants/password-reset.constants';

export function resolvePasswordResetErrorMessage(err: HttpErrorResponse): string {
    return err?.status === 503 ? passwordResetServiceUnavailableMessage : passwordResetErrorMessage;
}
